import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import "../../assets/css/MultiSwitch.css";

export default function MultiSwitch({ title = "", options = [], onChange = () => { }, activeOption = 0 }) {
    const [selectedOption, setSelectedOption] = useState(activeOption);
    const onClick = (option, value) => {
        onChange(option);
        setSelectedOption(value);
    }
    useEffect(() => { setSelectedOption(activeOption) }, [activeOption])
    return (
        <div className='MultiSwitchContainer'>
            <Row className='w-100'>
                <Col md="12" lg="6">
                    <div className='title d-flex align-items-center justify-content-start'>{title}</div>
                </Col>
                <Col md="12" lg="6" className='d-flex align-items-center justify-content-center flex-column'>
                    <div className='MultiSwitchHeaders'>
                        {options.map((option, value) => {
                            return <span key={value} onClick={() => onClick(option, value)} className={'option'}>{option.name}</span>
                        })}
                    </div>
                    <div className={`MultiSwitch ${!!options[selectedOption] ? options[selectedOption].color : "danger"}`}>
                        <div className={`circle circle-${selectedOption}`}>

                        </div>
                        {
                            options.map((option, value) => {

                                return (
                                    <div key={value} className={`MultiSwitchOption-${options.length} ${selectedOption == value ? "selected" : ""}`} onClick={() => onClick(option, value)}></div>
                                )
                            })
                        }
                    </div>
                </Col>
            </Row>
        </div>
    );
}